import { DateTime } from "luxon";

export enum LocalFileStatus {
    New = "New",
    Imported = "Imported",
    Error = "Error",
    Deleted = "Deleted"
}

export interface ILocalFileDTO {
    fileName: string;
    idContractorGlobal: string;
    contractorName: string;
    connectionString: string;
    idSupplierGlobal: string | null;
    supplierName: string;
    idStoreGlobal: string | null;
    storeName: string;
    supplierDocNum: string;
    supplierDocDate: DateTime | null;
    idImportedInvoiceGlobal: string | null;
    idInvoiceGlobal: string | null;
    status: LocalFileStatus;
    itemCount: number | null;
    sumIncVat: number | null;
    sumWithoutVat: number | null;
    vatSum: number | null;
}

export interface IImportFileViewDTO {
    fileName: string;
    idContractorGlobal: string;
    contractorName: string;
    connectionString: string;
    idSupplierGlobal: string | null;
    supplierName: string;
    idStoreGlobal: string | null;
    storeName: string;
    supplierDocNum: string;
    supplierDocDate: DateTime | null;
    idImportedInvoiceGlobal: string | null;
    idInvoiceGlobal: string | null;
    status: LocalFileStatus;
    itemCount: number | null;
    sumIncVat: number | null;
    sumWithoutVat: number | null;
    vatSum: number | null;
}

export interface IImportFilesFilterDTO {
    pageNumber: number;
    numberPerPage: number;
    fieldOrderBy?: string;
    orderDesc?: boolean;
    idContractorGlobal?: string | null;
    idSupplierGlobal?: string | null;
    idStoreGlobal?: string | null;
    fileName?: string;
    supplierDocNum?: string;
    search?: string;
    supplierDocDateFrom?: DateTime | null;
    supplierDocDateTo?: DateTime | null;
    status?: LocalFileStatus | null;
}

export interface IImportFilesBatchRequestDTO {
    files: ILocalFileDTO[];
    store: string;
    contractor?: string | null;
}

export interface ILoadAndGetImportedInvoiceByFileNameDTO {
    file: ILocalFileDTO;
    store: string;
}
